/* VISTA Caja y Stock PARA /caja-stock . 
Muestra las cajas y el stock del evento. */
import React, { useEffect, useState } from "react";
import { Alert, Box, Container, Snackbar, Tab, Tabs } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useParams } from "react-router-dom";
import { api } from "../../services/api";

import CajaTab from "../../components/VentaPresencial/CajaYStock/CajaTab";
import StockTab from "../../components/VentaPresencial/CajaYStock/StockTab";

const CajaYStock = () => {
  const { id } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [errorMsg, setErrorMsg] = useState('');
  const [showError, setShowError] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [vendedores, setVendedores] = useState([]);
  const [allTarifas, setAllTarifas] = useState([]);

  const [allCajas, setAllCajas] = useState([]);
  const [allStock, setAllStock] = useState([]);
  const [loadingCajas, setLoadingCajas] = useState(true);
  const [loadingStock, setLoadingStock] = useState(true);

   const fetchAllCajas = async () => {
    setLoadingCajas(true);
    const res = await api.caja.getAllCajas(id);
    if (res.status === 'success') {
      setAllCajas(res.data);
    }
    setLoadingCajas(false);
  };

  const fetchAllStock = async () => {
    setLoadingStock(true);
    const res = await api.stock.getAllStock(id);
    if (res.status === 'success') {
      setAllStock(res.data);
    }
    setLoadingStock(false);
  };

  useEffect(() => {
    const fetchVendedores = async () => {
      const res = await api.vendedores.getVendedores(id, '');
      if (res.status === 'success') {
        const vendedoresUnicos = [];
        const idsUsados = new Set();
        const emailsUsados = new Set();

        res.data?.forEach(v => {
          if (!idsUsados.has(v.id) && !emailsUsados.has(v.email)) {
            vendedoresUnicos.push({
              id: v.id,
              nombre: v.nombre || '',
              apellido: v.apellido || '',
              email: v.email || '',
              caja: v.caja || ''
            });
            idsUsados.add(v.id);
            emailsUsados.add(v.email);
          }
        });
        setVendedores(vendedoresUnicos);
      }
    };

    const fetchAllTarifas = async () => {
      const res = await api.tarifas.getTarifaByEventoWithoutPagination(id);
      if (res.status === 'success') setAllTarifas(res.data.tarifas);
    };

    fetchVendedores();
    fetchAllTarifas();
    fetchAllCajas();
    fetchAllStock();
  }, [id]);

  const showSuccessMessage = (message) => {
    setSuccessMsg(message);
    setShowSuccess(true);
  };

  const showErrorMessage = (message) => {
    setErrorMsg(message);
    setShowError(true);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="md" sx={{ mt: 2 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          sx={{
            '& .MuiTab-root': {
              fontWeight: 600,
              fontSize: '16px',
              textTransform: 'none'
            },
            '& .Mui-selected': {
              color: '#5656ff !important'
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#5656ff'
            }
          }}
        >
          <Tab label="Cajas" />
          <Tab label="Stock" />
        </Tabs>
      </Box>

      {tabValue === 0 && (
        <CajaTab
          eventoId={id}
          vendedores={vendedores}
          allTarifas={allTarifas}
          allCajas={allCajas}
          loadingCajas={loadingCajas}
          refetchCajas={fetchAllCajas}
          isMobile={isMobile}
          onSuccess={showSuccessMessage}
          onError={showErrorMessage}
        />
      )}

      {tabValue === 1 && (
        <StockTab
          eventoId={id}
          allTarifas={allTarifas}
          allStock={allStock}
          loadingStock={loadingStock}
          refetchStock={fetchAllStock}
          onSuccess={showSuccessMessage}
          onError={showErrorMessage}
        />
      )}

      <Snackbar open={showError} autoHideDuration={4000} onClose={() => setShowError(false)}>
        <Alert onClose={() => setShowError(false)} severity="error" sx={{ width: '100%' }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <Snackbar open={showSuccess} autoHideDuration={4000} onClose={() => setShowSuccess(false)}>
        <Alert onClose={() => setShowSuccess(false)} severity="success" sx={{ width: '100%' }}>
          {successMsg}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default CajaYStock;